"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rdf_string_1 = require("rdf-string");
const sparqlalgebrajs_1 = require("sparqlalgebrajs");
const sparqlee_1 = require("sparqlee");
const bus_query_operation_1 = require("@comunica/bus-query-operation");
const SortIterator_1 = require("./SortIterator");
/**
 * A comunica OrderBy Sparqlee Query Operation Actor.
 */
class ActorQueryOperationOrderBySparqlee extends bus_query_operation_1.ActorQueryOperationTypedMediated {
    constructor(args) {
        super(args, 'orderby');
        this.window = args.window || Infinity;
    }
    async testOperation(pattern, context) {
        // Will throw error for unsupported operators
        for (let expr of pattern.expressions) {
            expr = this.extractSortExpression(expr);
            const _ = new sparqlee_1.AsyncEvaluator(expr);
        }
        return true;
    }
    async runOperation(pattern, context) {
        const outputRaw = await this.mediatorQueryOperation.mediate({ operation: pattern.input, context });
        const output = bus_query_operation_1.ActorQueryOperation.getSafeBindings(outputRaw);
        const options = { window: this.window };
        let bindingsStream = output.bindingsStream;
        for (let expr of pattern.expressions) {
            const origin = output.bindingsStream;
            const isAscending = this.isAscending(expr);
            expr = this.extractSortExpression(expr);
            // Transform the stream by annotating it with the expr result
            const evaluator = new sparqlee_1.AsyncEvaluator(expr);
            const transform = async (bindings, next) => {
                try {
                    const result = await evaluator.evaluate(bindings);
                    transformedStream._push({ bindings, result });
                }
                catch (err) {
                    if (!sparqlee_1.isExpressionError(err)) {
                        bindingsStream.emit('error', err);
                    }
                    transformedStream._push({ bindings, result: undefined });
                }
                next();
            };
            const transformedStream = origin.transform({ transform });
            // Sort the annoted stream
            const sortedStream = new SortIterator_1.SortIterator(transformedStream, (a, b) => {
                const orderA = rdf_string_1.termToString(a.result);
                const orderB = rdf_string_1.termToString(b.result);
                if (!orderA || !orderB) {
                    return 0;
                }
                return orderA > orderB === isAscending ? 1 : -1;
            }, options);
            // Remove the annotation
            bindingsStream = sortedStream.map(({ bindings, result }) => bindings);
        }
        return { type: 'bindings', bindingsStream, metadata: output.metadata, variables: output.variables };
    }
    // Remove descending operator if necessary
    extractSortExpression(expr) {
        const { expressionType, operator } = expr;
        if (expressionType !== sparqlalgebrajs_1.Algebra.expressionTypes.OPERATOR) {
            return expr;
        }
        return (operator === 'desc')
            ? expr.args[0]
            : expr;
    }
    isAscending(expr) {
        const { expressionType, operator } = expr;
        if (expressionType !== sparqlalgebrajs_1.Algebra.expressionTypes.OPERATOR) {
            return true;
        }
        return operator !== 'desc';
    }
}
exports.ActorQueryOperationOrderBySparqlee = ActorQueryOperationOrderBySparqlee;
//# sourceMappingURL=ActorQueryOperationOrderBySparqlee.js.map